import {invertedString} from './englishHebrewKeyMap';

const stripPunctuation = (s) => s.replace(/[^\p{L}\p{N}\s]/gu, '');

export const localSearch = (array, value, searchColumns) => {
    const absoluteValue = invertedString(value);

    const searchAllColumns = !Array.isArray(searchColumns) || searchColumns.length === 0;

    const filteredList = array.filter((item) => {
        if(!item) return false;

        const keysToSearchIn = searchAllColumns ? Object.keys(item) : searchColumns;

        return keysToSearchIn.some((key) => {
            const columnValue = stripPunctuation(String(item[key]).toLowerCase());
            const searchTerms = value.split(' ');
            const absoluteSearchTerms = absoluteValue.split(' ');

            return (
                searchTerms.every((term) => columnValue.includes(stripPunctuation(term.toLowerCase()))) ||
                absoluteSearchTerms.every((term) => columnValue.includes(stripPunctuation(term.toLowerCase())))
            );
        });
    });

    return filteredList;
};
